import createPersistedState from "vuex-persistedstate";
import { createStore } from 'vuex'
import axios from "axios"
import { i18n } from "../main";

import { getSearchData, getExportData, getHighlightData, getAggregations } from './helpers/functions.js'

export default createStore({
  state: {
    loggedUser: "",
    URL_BACKEND: "",
    ENDPOINT_EXPORT: "",
    ENDPOINT_SEARCH: "",
    ENDPOINT_HIGHLIGHT: "",
    recordsPerPage: 0,

    searchParams: {
      "searchPhrase": "",
      "searchStart": 0,
      "itemsPerPage": 10,
      "tab": "",
      "aggs": {},
      "filters": {},
      "sort": {},
    },
    searchResults: [],
    resultCount: 0,
    pageNumber: 1,

    allTabs:{},
    selectedTab: {},

    highlightedId: "",
    highlightText: "",

    top10Expressions: [],
    recentExpressions: [],

    showOverlay: false,
    overlayMessage: "",

    msg: [],
  },
  mutations: {
    setGlobalConfig(state, { URL_BACKEND, ENDPOINT_SEARCH, ENDPOINT_EXPORT, ENDPOINT_HIGHLIGHT }) {
      state.URL_BACKEND = URL_BACKEND;
      state.ENDPOINT_SEARCH = ENDPOINT_SEARCH;
      state.ENDPOINT_EXPORT = ENDPOINT_EXPORT;
      state.ENDPOINT_HIGHLIGHT = ENDPOINT_HIGHLIGHT;
    },
    setLoggedUser(state, loggedUser) {
      state.loggedUser = loggedUser
    },

    setSearchParams(state, newParams) {
      state.searchParams = {
        ...state.searchParams,
        ...newParams
      }
    },
    setSearchResults (state, searchResults) {
       state.searchResults = searchResults
    },
    setResultCount (state, resultCount) {
      state.resultCount = resultCount
    },
    setPageNumber (state, number) {
      state.pageNumber = number
    },
    setItemsPerPage(state, value) {
      state.searchParams.itemsPerPage = value;
    },
    setAggregations(state, { metadataObjects, aggFieldForTab }) {
      console.log(metadataObjects);
      state.searchParams.aggs = getAggregations(['all'], metadataObjects, aggFieldForTab);
    },

    setAllTabs (state, tabs) {
       state.allTabs = tabs
    },
    setSelectedTab (state, selectedTab) {
       state.selectedTab = selectedTab
    },

    settop10Expressions(state, top10Expressions) {
      state.top10Expressions = top10Expressions;
    },
    setrecentExpressions(state, recentExpressions) {
      state.recentExpressions = recentExpressions;
    },

    setHighlightedId (state, highlightedId) {
      state.highlightedId = highlightedId
    },
    setHighlightText(state, highlightText) {
      state.highlightText = highlightText
    },

    setShowOverlay(state, payload) {
      state.showOverlay = payload.show;
      state.overlayMessage = payload.message;
    },
    pushMsg (state, data){
      state.msg.push({
        type: data.type, 
        text: data.text
      })
      setTimeout(() => {
        state.msg.shift()
      }, 7000)
    },
    popMsg (state) {
      state.msg.shift()
    },
    clearMsg (state) {
      state.msg.length = 0
    },

    calculatePageCount (state) {
      state.pageCount = state.resultCount > 0 ? Math.ceil(state.resultCount / state.recordsPerPage) : 0;
    }
  },
  actions: {
    showOverlay({ commit }, message) {
      commit('setShowOverlay', { show: true, message }); // Pass message to the mutation
    },
    hideOverlay({ commit }) {
      commit('setShowOverlay', { show: false, message: '' }); // Clear message when hiding overlay
    },

    // Perform search on the input phrase
    async search (context) {
        context.commit('setSearchResults', {})
        try {
          context.dispatch('showOverlay', i18n.global.t("LoadingMessages.searchLoading"))

          const searchData = getSearchData(context.state.searchParams, context.state.pageNumber)
          await axios.post(context.state.URL_BACKEND + context.state.ENDPOINT_SEARCH, searchData
            ).then(result => {
              context.dispatch('hideOverlay')

              if (result.status == 200) {
                context.commit('setSearchResults', result.data.response.docs)
                context.commit('setAllTabs', result.data.tabs)
                if(Object.keys(context.state.selectedTab).length === 0){
                  context.commit('setSelectedTab', result.data.tabs[0])
                }
                context.commit('setResultCount', result.data.response.numFound)
                if (result.data.overflow){
                  console.warn('SEARCH RESULT OVERFLOW', result.data.overflow)
                  context.commit('pushMsg', {type: 'warn', text: 'Zobrazenie obmädzené na 5000 záznamov'})
                }
              } else {
                context.commit('pushMsg', {type: 'error', text: 'Vo vyhľadávaní sa vyskytla chyba'})
              }
            })
        } catch (err) {
          context.dispatch('hideOverlay')
          context.commit('pushMsg', {type: 'error', text: 'Vo vyhľadávaní sa vyskytla chyba'})
          console.log('ERROR !', err)
        }
    },
    
    // Export search results
    async export (context, exportFormat) {
      context.dispatch('showOverlay')
      try {
        const exportData = getExportData(context.state.searchParams, context.state.pageNumber, exportFormat)
        const response = await axios.post(context.state.URL_BACKEND + context.state.ENDPOINT_EXPORT, exportData, {
          responseType: 'blob'
        });

        context.dispatch('hideOverlay');

        if (response.status !== 200) {
          context.commit('pushMsg', { type: 'error', text: 'V exportovaní výsledkov sa vyskytla chyba' });
          return;
        }

        // Create a blob URL for the response data
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = URL.createObjectURL(blob);

        // Create a temporary <a> element to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', response.headers['content-disposition']?.split('filename=')[1] || `export.${exportFormat}`);
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Cleanup
        URL.revokeObjectURL(downloadUrl);
      }  catch (err) {
        context.dispatch('hideOverlay')
        context.commit('pushMsg', {type: 'error', text: 'V exportovaní výsledkov sa vyskytla chyba'})
        console.log('ERROR !', err)
      }
    },

    // Fetch document highlight
    async fetchDocumentContext(context) {
      try {
        const highlightedData = getHighlightData(context.state.highlightedId)
        await axios.post(context.state.URL_BACKEND + context.state.ENDPOINT_HIGHLIGHT, highlightedData
          ).then(result => {
            if (result.status == 200) {
              var documentText = null;
              try {
                documentText = result.data.response.docs[0].content_txt_sk
                context.commit("setHighlightText", documentText)
              } catch (e) {
                console.error(e);
              }
            } else {
              context.commit("setHighlightText", '')
              context.commit('pushMsg', {type: 'error', text: 'Chyba pri zobrazení highlightu'})
            }
          })
      } catch (err) {
        console.log("Error:", err)
      }
    },
  },
  getters: {
    showOverlay: state => state.showOverlay,
    overlayMessage: state => state.overlayMessage,
    getSearchPhrase: state => state.searchParams.searchPhrase
  },
  modules: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
})

